import React from "react";
import { Flex, Card, Avatar } from "antd";
import Header from "../components/Header/Header";
import MyText from "../../components/UI/Text/MyText";
import Footer from "../components/Footer/Footer";
import doc from "./document.json";
import title_image from "../../images/book.png";

const { Meta } = Card;

const DocumentPage = () => {
  return (
    <Flex
      style={{ width: "100%", position: "relative" }}
      vertical
      align={"center"}
      justify={"flex-start"}
    >
      <Header />
      <Flex
        style={{
          width: "100%",
          paddingTop: 250,
          position: "relative",
          overflow: "hidden",
          paddingBottom: 50,
        }}
        vertical
        align={"center"}
        justify={"flex-start"}
      >
        <Flex
          style={{ width: "100%", maxWidth: 1440, position: "relative" }}
          vertical
          gap={35}
          align={"center"}
          justify={"flex-start"}
        >
          <MyText style={{ fontSize: "2rem", fontWeight: "bold" }}>
            Гарын авлага
          </MyText>

          <Flex
            style={{
              width: "100%",
              flexWrap: "wrap",
              gap: 20,
              justifyContent: "center",
            }}
          >
            {doc.map((item) => (
              <Card
                key={item.id}
                style={{ maxWidth: 345, width: "100%" }}
                cover={
                  <img
                    alt="Document"
                    src={title_image}
                    style={{ height: 150, objectFit: "cover" }}
                  />
                }
              >
                <Meta
                  avatar={
                    <Avatar style={{ backgroundColor: "silver" }}>
                      {item.id}
                    </Avatar>
                  }
                  title={
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        color: "inherit",
                        textDecoration: "none",
                        cursor: "pointer",
                      }}
                    >
                      {item.title}
                    </a>
                  }
                />
              </Card>
            ))}
          </Flex>
        </Flex>
      </Flex>
      <Footer />
    </Flex>
  );
};

export default DocumentPage;
